import api from '@shared/services/api';

export const jobDescriptionsService = {
    getJobDescriptions: async (companyId, searchParams = {}) => {
        try {
            const params = {};
            
            if (searchParams.fileName) {
                params.fileName = searchParams.fileName.trim();
            }
            if (searchParams.description) {
                params.description = searchParams.description.trim();
            }
            if (searchParams.active !== undefined && searchParams.active !== null) {
                params.active = searchParams.active;
            }

            const response = await api.get(`/job-description`, { params });
            return response.data;
        } catch (error) {
            console.error('❌ [jobDescriptionsService] Error fetching job descriptions:', error);
            throw error;
        }
    },
    createJobDescription: async (jobDescriptionData) => {
        try {
            // For FormData, we need to let the browser set the Content-Type header automatically
            const response = await api.post(`/job-description`, jobDescriptionData, {
                headers: {
                    'Content-Type': undefined, // Let browser set it automatically for FormData
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error creating job description:', error);
            throw error;
        }
    },
    updateJobDescription: async (companyId, jobDescriptionData) => {
        try {
            // Check if it's FormData (file upload) or regular JSON data
            const isFormData = jobDescriptionData instanceof FormData;
            
            const config = isFormData ? {
                headers: {
                    'Content-Type': undefined, // Let browser set it automatically for FormData
                },
            } : {};
            
            const response = await api.put(`/job-description/${companyId}`, jobDescriptionData, config);
            return response.data;
        } catch (error) {
            console.error('Error updating job description:', error);
            throw error;
        }
    },
    deleteJobDescription: async ( jobDescriptionId) => {
        try {
            const response = await api.delete(`/job-description/${jobDescriptionId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting job description:', error);
            throw error;
        }
    }
}